import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useMemo, useContext } from 'react';
import { withTitan } from '../../hocs/withTitan/withTitan.js';

const SteppedFormContext = createContext({});
const useSteppedForm = () => {
  const context = useContext(SteppedFormContext);
  if (context === undefined) {
    throw new Error('useSteppedForm must be used within a SteppedForm');
  }
  return context;
};
const SteppedFormProvider = /*#__PURE__*/withTitan(({
  children,
  defaultActiveIndex = 0,
  formId,
  buttonEdit,
  totalSteps
}) => {
  const [activeStepIndex, setActiveStepIndex] = useState(defaultActiveIndex);
  const isFirstStep = activeStepIndex <= 0;
  const isLastStep = activeStepIndex >= totalSteps - 1;
  const goToNextStep = useCallback(() => {
    if (!isLastStep) {
      setActiveStepIndex(activeStepIndex + 1);
    }
  }, [activeStepIndex, isLastStep]);
  const goToPreviousStep = useCallback(() => {
    if (!isFirstStep) {
      setActiveStepIndex(activeStepIndex - 1);
    }
  }, [activeStepIndex, isFirstStep]);
  const goToStep = useCallback(stepIndex => {
    if (stepIndex >= 0 && stepIndex < totalSteps) {
      setActiveStepIndex(stepIndex);
    }
  }, [totalSteps, setActiveStepIndex]);
  const steppedFormValue = useMemo(() => ({
    nextStep: goToNextStep,
    previousStep: goToPreviousStep,
    formId,
    buttonEdit,
    activeStepIndex,
    isFirstStep,
    isLastStep,
    totalSteps,
    goToStep
  }), [activeStepIndex, formId, buttonEdit, goToNextStep, goToPreviousStep, goToStep, totalSteps, isFirstStep, isLastStep]);
  return jsx(SteppedFormContext.Provider, {
    value: steppedFormValue,
    children: children
  });
}, {
  name: 'SteppedFormProvider'
});

export { SteppedFormProvider, useSteppedForm };
//# sourceMappingURL=SteppedFormProvider.js.map
